export default {
    black: '#303030',
    white: '#FFFFFF',
    primary: '#2C5B8A',
    primaryDisabled: '#94A9CA',
    textPrimary: '#202225',
    textSecondary: '#747576',

    blackBackgroundHover: '#474848',
    blackBackgroundFocus: '#4F5051',
    blackBackgroundActive: '#575859',

    blue60: '#2972C9',
    blueLight: '#85C4E2',
    blueLighter: '#ACC8F6',
    fieldRequiredYellow: '#FFFFCC',
    orange: '#F8972B',
    orangeDark: '#EE9129',
    orange99: '#FFEDDC',
    redDark: '#BB0000',

    purpleDark: '#5E35B1',
    purpleLight: '#AD61DC',
    purpleLightest: '#EDE7F6',

    lightLinkDefault: '#C3CDEE',
    linkLightBlue: '#A3B5E5',

    // NOTE: Colors and their uses are still TBD - These may change to something more generic.
    primaryBackgroundColorActive: '#406A95',
    primaryBackgroundColorFocus: '#50779F',

    revPrimaryBackgroundColorActive: '#545454',
    revPrimaryBackgroundColorFocus: '#545454',

    whiteBackgroundColorActive: '#EEF2F6',
    whiteBackgroundColorFocus: '#E6EBF1',

    primary60: '#4F7095',
    primary95: '#E2EAF9',
    primary99: '#F3F6FC',

    neutral10: '#001940',
    neutral30: '#555E68',
    neutral50: '#858C93',
    neutral60: '#9FA5AC',
    neutral70: '#B7BCC1',
    neutral80: '#CFD2D5',
    neutral90: '#E7E9EA',
    neutral95: '#EDEFF1',
    neutral99: '#F7F8FA',

    iconButtonDefault: '#333333',

    lightSecondaryDefault: '#DFE3E6',
    lightSecondaryFocus: '#D4DBE0',

    hoverBackground: '#DEE3E9',
    disabledDarkGrey: '#A6A6A7',
    disabledLightGrey: '#DBDDDE',
    blackDark: '#414141',

    primaryBorderColorFocus: '#0A88C5',

    revPrimary02: '#F8F9FA',
    revPrimary04: '#CBD0D5',
    revPrimary05: '#ADB5BD',
    revPrimary06: '#6C757D',

    revHoverNeutral03: '#E0E3E5',
    revNeutral03: '#D5D9DD',

    whiteActive: '#E9ECEF',
    neutralHover: '#EEEFF0',
    neutralActive: '#E4E5E6',

    approvedGreen: '#45AA37',
    pendingOrange: '#D37800',
    inactiveRed: '#DB1818',

    green30: '#35822B',
    red50: '#C10004',
};
